import React from 'react';
import { siteConfig } from '../data/siteConfig';
import { formatEuro } from '../utils/currency';
type BonusOfferTagProps = {
  referencePrice?: number | null;
  onDark?: boolean;
};
export function BonusOfferTag({
  referencePrice = null,
  onDark = false
}: BonusOfferTagProps) {
  return <div className="flex flex-wrap items-center gap-x-3 gap-y-1.5" data-id="element-43" data-mp="2rrq4h97euo25">
      <span className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-leaf-soft px-3 py-1 text-xs font-bold tracking-wide text-leaf" data-id="element-44" data-mp="2rpvfnjt0qbss">
        {referencePrice !== null && <s className="font-medium text-leaf/70" data-id="element-45" data-mp="31okvl71ctm6e">{formatEuro(referencePrice)}</s>}
        OFFERT · 0 €
      </span>
      <span className={`text-sm ${onDark ? 'text-ivory/80' : 'text-ink/70'}`} data-id="element-46" data-mp="36iyx7r6m0pji">
        Inclus avec le pack à {siteConfig.price}
      </span>
    </div>;
}